import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';
import Button from './Button';

const AuthHeader = ({ isAuthenticated = false, userName = '', userSubscription = 'free' }) => {
  const navigate = useNavigate();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleSignIn = () => {
    navigate('/signup-and-onboarding');
  };

  const handleSignUp = () => {
    navigate('/signup-and-onboarding');
  };

  const handleLogout = () => {
    setIsDropdownOpen(false);
    navigate('/landing-page');
  };

  const handleProfile = () => {
    setIsDropdownOpen(false);
    navigate('/settings');
  };

  const handleBilling = () => {
    setIsDropdownOpen(false);
    navigate('/billing');
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  return (
    <header className="fixed top-0 left-0 right-0 h-16 bg-card border-b border-border z-50 elevation-sm">
      <div className="max-w-7xl mx-auto h-full px-6 flex items-center justify-between">
        <Link to="/landing-page" className="flex items-center transition-smooth hover:opacity-80">
          <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-primary/20">
            <Icon name="Zap" size={24} color="var(--color-primary)" />
          </div>
          <span className="ml-3 text-xl font-heading font-semibold text-foreground">
            Business Jadhak
          </span>
        </Link>

        {!isAuthenticated ? (
          <div className="flex items-center gap-3">
            <Button
              variant="ghost"
              size="default"
              onClick={handleSignIn}
              className="hidden sm:inline-flex"
            >
              Sign In
            </Button>
            <Button
              variant="default"
              size="default"
              onClick={handleSignUp}
              iconName="ArrowRight"
              iconPosition="right"
            >
              Get Started
            </Button>
          </div>
        ) : (
          <div className="relative">
            <button
              onClick={toggleDropdown}
              className="flex items-center gap-3 px-3 py-2 rounded-md transition-smooth hover:bg-muted"
              aria-expanded={isDropdownOpen}
              aria-haspopup="true"
            >
              <div className="w-9 h-9 rounded-full bg-primary/20 flex items-center justify-center">
                <Icon name="User" size={18} color="var(--color-primary)" />
              </div>
              <div className="hidden sm:block text-left">
                <p className="text-sm font-medium text-foreground font-body">
                  {userName || 'User Account'}
                </p>
                <p className="text-xs text-muted-foreground font-caption capitalize">
                  {userSubscription} Plan
                </p>
              </div>
              <Icon
                name="ChevronDown"
                size={16}
                color="var(--color-muted-foreground)"
                className={`transition-smooth ${isDropdownOpen ? 'rotate-180' : ''}`}
              />
            </button>

            {isDropdownOpen && (
              <>
                <div
                  className="fixed inset-0 z-40"
                  onClick={() => setIsDropdownOpen(false)}
                  aria-hidden="true"
                />
                <div className="absolute right-0 top-full mt-2 w-56 bg-popover border border-border rounded-md elevation-lg z-50 overflow-hidden">
                  <div className="py-2">
                    <button
                      onClick={handleProfile}
                      className="w-full flex items-center px-4 py-2.5 text-sm text-popover-foreground hover:bg-muted transition-smooth"
                    >
                      <Icon name="User" size={16} color="currentColor" />
                      <span className="ml-3 font-body">Profile Settings</span>
                    </button>
                    <button
                      onClick={handleBilling}
                      className="w-full flex items-center px-4 py-2.5 text-sm text-popover-foreground hover:bg-muted transition-smooth"
                    >
                      <Icon name="CreditCard" size={16} color="currentColor" />
                      <span className="ml-3 font-body">Billing & Plans</span>
                    </button>
                    <div className="my-1 border-t border-border" />
                    <button
                      onClick={handleLogout}
                      className="w-full flex items-center px-4 py-2.5 text-sm text-destructive hover:bg-destructive/10 transition-smooth"
                    >
                      <Icon name="LogOut" size={16} color="var(--color-destructive)" />
                      <span className="ml-3 font-body">Sign Out</span>
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
        )}
      </div>
    </header>
  );
};

export default AuthHeader;